import Component from '../abstracts/Component';
import GalleryManager from '../utils/GalleryManager';
// import FiltersComponent from '../components/FiltersComponent';
import {isMobile, MobileBreakpoint} from '../utils/MobileUtils';

export default class ShortcutComponent extends Component {

  get SELECTORS() {
    return {
      scroller: '.shortcut__simplebar-wrapper',
      itemsContainer: '.shortcut__items',
      item: '.shortcut__item',
      titleContainer: '.shortcut__title-container',
      input: '[type="radio"]',
      container: '.shortcut',
      shorcutWrapper: '.shortcut__wrapper',
      //END WIP
      responsesContainer: '[data-shortcut-products]',
      firstShortcut: '#shortcut_0',
      breadcrumbsWrapper: '.breadcrumb__wrapper',
    };
  }

  get QUERY_PARAMS() {
    return {
      base: '?save=false&q=:topRated',
      end: ':sortBy:topRated&size=36',
    }
  }

  get COMPONENTNAME() {
    return 'ShortcutComponent';
  }

  constructor(htmlEl) {
    super(htmlEl);

    this.firstShortcut = document.querySelector(this.SELECTORS.firstShortcut);
    this.container = document.querySelector(this.SELECTORS.container);
    this.container = document.querySelector(this.SELECTORS.shorcutWrapper);
    this.breadcrumbsWrapper = document.querySelector(this.SELECTORS.breadcrumbsWrapper);
  }

  render() {
    super.render();
    this.galleryManager = new GalleryManager(
      this.SELECTORS,
      this.$component,
      this.moduleLoader
    );
    var viewportWidth = $(window).width();
    var wrapperWidth = $('.shortcut__wrapper').width();
    if ( wrapperWidth > viewportWidth ) {
        $('.shortcut').css('align-items', 'start');
    }
    else {
        $('.shortcut').css('align-items', 'center');
    }
    this.bindEvents();
  }


  bindEvents() {
    let ctx = this;
    if (this.firstShortcut != null && this.firstShortcut != 'undefined') {
      this.firstShortcut.addEventListener('click', (e) => {
        if (!e.currentTarget.classList.contains('selected')) {
          if (e.currentTarget.dataset.isLink === "true") {
            window.open(e.currentTarget.dataset.href, '_self');
          } else {
            // this.FiltersComponent.shortcutResetFilters();
            this.$emit(this.$customEvents.SHORTCUT_EVENTS.update, {
                fullQuery:'', resetFilters:true
            });
            this.hideBreadcrumbs();
            this.toggleFilters(false);
          }
        }
      });
    }

    $(window).on('resize', function(){
        var viewportWidth = $(window).width();
        var wrapperWidth = $('.shortcut__wrapper').width();
        if ( wrapperWidth > viewportWidth ) {
            $('.shortcut').css('align-items', 'start');
        }
        else {
            $('.shortcut').css('align-items', 'center');
        }
    });

    const url = new URL(window.location);
    const urlSearchParams = new URLSearchParams(url.search);
    this.qParams = urlSearchParams;
    let isAtLeastOneSelected = false;
    
    document.querySelectorAll('.shortcut__item').forEach((item) => {

      if (item.dataset.isLink != '' && item.dataset.isLink != 'false' && item !== this.firstShortcut) {
        if (window.location.pathname === item.dataset.href) {
          item.classList.add('selected');
          item.querySelector('input').setAttribute('checked', true);
          isAtLeastOneSelected = true;
        }
      } else {
        if (item.id.includes(`${this.qParams.get('shortcut')}`)) {
          item.classList.add('selected');
          item.querySelector('input').setAttribute('checked', true);
          isAtLeastOneSelected = true;
        }
      }

      item.addEventListener('click', (e) => {

        if (!item.classList.contains('selected')) {

          //card select behaviour
          item.classList.toggle('selected');
          item.querySelector('input').setAttribute('checked', true);
          document.querySelectorAll(".shortcut__item").forEach((otherEl) => {
            if (otherEl.id !== item.id) {
              otherEl.classList.remove('selected');
              otherEl.querySelector('input').removeAttribute('checked');
            }
          });

          //if not link card and sku populated
          if (item.dataset.isLink == 'false' && item.dataset.products) {
            this.qParams.set('shortcut', item.dataset.code);

            let productsArray = item.dataset.products.split(',');
            let query = '';
            productsArray.forEach((productCode) => {
              if (productCode.length == 13) {
                query += ':code:' + productCode;
              }
            });
            this.log('fullQuery ', query);
            let fullQuery = '?isRefineSearch=true&q='.concat(':topRated').concat(query).concat(`&shortcut=${this.qParams.get('shortcut')}`);

            this.$emit(this.$customEvents.SHORTCUT_EVENTS.update, {
                fullQuery:fullQuery
            });
            this.showBreadcrumbs(item.dataset.shortcutTitle);
            this.toggleFilters();
          }

          //if link card and href populated
          if (item.dataset.isLink == 'true' && item.dataset.href) {
            window.open(item.dataset.href, '_self');
          }
        } else {
          //de-select card
          if(item.id != 'shortcut_0'){
            this.qParams.delete('shortcut');
            
            item.classList.toggle('selected');
            this.hideBreadcrumbs();
            item.querySelector('input').removeAttribute('checked');
            if (this.firstShortcut != null && this.firstShortcut != 'undefined') {
              if (this.firstShortcut.dataset.isLink == "false") {
                  this.firstShortcut.classList.add('selected');
                  this.firstShortcut.querySelector('input').setAttribute('checked', true);
              }
            }
            this.$emit(this.$customEvents.SHORTCUT_EVENTS.update, {
                fullQuery:'', resetFilters:true
            });
            // this.FiltersComponent.filterQuery(false);
            // this.FiltersComponent.shortcutResetFilters();
            this.toggleFilters(false);
          }
        }
      });
    });
    if (!isAtLeastOneSelected) {
      this.firstShortcut.classList.add('selected');
      this.firstShortcut.querySelector('input').setAttribute('checked', true);
    }
  }

  showBreadcrumbs(title) {
    let a = this.breadcrumbsWrapper.querySelector('a.shortcut-page');
    a.innerHTML = title.toUpperCase();
    this.breadcrumbsWrapper.querySelectorAll('.shortcut-page').forEach((el) => {
      el.style.display = 'inline-block';
    });
  }

  hideBreadcrumbs() {
    this.breadcrumbsWrapper.querySelectorAll('.shortcut-page').forEach((el) => {
      el.style.display = 'none';
    });
  }

  toggleFilters(bool = true) {
    if (bool) {
      document.querySelector('.filter-bar-left').style.visibility = 'hidden';
    } else {
      document.querySelector('.filter-bar-left').style.visibility = 'visible';
    }
  }

}

